import { createEnvironmentRpcCommand } from "@t3tools/client-runtime/state/runtime";
import { createVmEnvironmentAtoms } from "@t3tools/client-runtime/state/vm";
import { WS_METHODS } from "@t3tools/contracts";

import { connectionAtomRuntime } from "../connection/runtime";

export const vmEnvironment = {
  ...createVmEnvironmentAtoms(connectionAtomRuntime),
  desktopOpen: createEnvironmentRpcCommand(connectionAtomRuntime, {
    label: "environment-data:vm:desktop-open",
    tag: WS_METHODS.vmDesktopOpen,
  }),
};
